import {styled} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

const StyledListItem = styled(ListItem)(({theme, isselected}) => ({
  color: theme.palette.primary.main,
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: isselected === 'true' ? theme.palette.white : 'rgba(0, 0, 0, 0.04)',
  },
  ...(isselected === 'true'
    ? {
        backgroundColor: theme.palette.white,
        '&:before': {
          background: theme.palette.primary.main,
          width: '4px',
          display: 'block',
          height: '100%',
          position: 'absolute',
          zIndex: '2',
          content: '" "',
          left: '0',
          borderRadius: '20px',
        },
      }
    : {}),
}));

export default function CustomList({filters, selectedFilter, setSelectedFilter}) {
  const onClick = (filter) => {
    setSelectedFilter(filter);
  };
  return (
    <List>
      {filters?.map((filter) => (
        <StyledListItem
          key={filter.id}
          isselected={(selectedFilter?.id === filter?.id)?.toString()}
          onClick={() => onClick(filter)}
        >
          <ListItemText primary={filter.id} />
        </StyledListItem>
      ))}
    </List>
  );
}
